import { globalStore } from '@/lib/global-atom-store';
import { atom, useAtom } from 'jotai';

const inputTeamTextAtom = atom<string>('');

export const useTeamInputText = () => {
  const [inputText, setInputText] = useAtom(inputTeamTextAtom, {
    store: globalStore,
  });

  const insertText = (text: string) => {
    setInputText(text);
  };

  return {
    inputText,
    setInputText,
    insertText,
  };
};
